// Create a new component called ShopSelectorRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../types';
import * as routes from '../utils/routes';

const ShopSelectorRoute: React.FC = () => {
    const { token } = useSelector((state: RootState) => ({
        token: state.auth?.user?.token
    }));

    if (!token) {
        console.log("User not authenticated, redirecting to login");
        return <Navigate to={routes.LOGIN} />;
    }

    return <Outlet />;
};

export default ShopSelectorRoute;